'use strict';

import { getDepositBanks, getDepositAccountName, getDepositContactEmail } from '../utils/pricetravel/shared/bankUtils';

window.app.controller('PdvController', controller);

controller.$inject = ["$http"];

function controller($http) {

    let vm = this;
    let setting = window.__pt.settings;
    let fn = window.__pt.fn || {};
    let cultureData = window.__pt.cultureData || {};
    vm.responsePayment = {
        fixedPayments: [],
        monthInterestFree: [],
        loading: true
    };

    vm.onLoadPayment = (modal, btnTitle, btnText) => {
        __modal = modal;
        vm.showModal(__modal, btnTitle, btnText);
        onSearchPaymentMethod();
    }

    vm.showModal = (modal, btnTitle, btnText) => {
        $(`#${modal}`).modal("show");

        if (modal == "modal-payform" || modal == "modal-contact") {
            tracker.selectContent(btnTitle, btnText);
        }
    }

    vm.onClosed = (modal) => {
        $(`#${modal}`).modal("hide");
    }

    function onSearchPaymentMethod() {
        if (vm.responsePayment.fixedPayments.length || vm.responsePayment.monthInterestFree.length) { return; }
        let params = {
            channel: setting.site.channel,
            language: cultureData.internalCultureCode,
            currency: setting.site.currency,
            isdeposit: true
        }
        $http.get(setting.site.endPoints.paymentMethodUrl, { params: params }).then(onSuccessPaymentMethods, onError)

    }



    function onSuccessPaymentMethods(response) {
        const data = response.data || [];
        const monthInterestFree = data.monthInterestFree ? data.monthInterestFree.options : [];
        const groupedPayments = monthInterestFree.reduce((groups, item) => {
            const maxMonths = Math.max(...item.paymentPlans);
            if (!groups[maxMonths]) {
                groups[maxMonths] = [];
            }
            groups[maxMonths].push(item);
            return groups;
        }, {});
        const sortedEntries = Object.entries(groupedPayments).sort(([keyA], [keyB]) => Number(keyB) - Number(keyA));

        const depositBanks = getDepositBanks(data);
        const depositAccountName = getDepositAccountName(data);
        const depositContactEmail = getDepositContactEmail(data);

        const paymentMethods = {
            fixedPayments: data.fixedPayments
                .map(fixedPayments => fixedPayments.options)
                .reduce((prev, curr) => prev.concat(curr), []),
            monthInterestFree: sortedEntries,
            quotasPayments: data.quotasPayments ? data.quotasPayments.options : [],
            otherPayments: data.otherPayments ? data.otherPayments.options : [],
            depositBanks: depositBanks,
            depositAccountName: depositAccountName,
            depositContactEmail: depositContactEmail,
            loading: false,
            maxmsi: data.monthInterestFree ? data.monthInterestFree.title : ""
        };
        vm.responsePayment = paymentMethods;
        $('#loader-page').addClass('d-none');
        $('#pdv-content-wrapper').removeClass('d-none');
    }
    function onError(response) {
        console.log(response)
    }

    function init() {
        onSearchPaymentMethod();
    }

    init();
}
